import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("ap_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("ap_lang", lang);
    document.documentElement.lang = lang === "hi" ? "hi" : "en";
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    tr: (obj) => (obj && obj[lang]) || (obj && obj.en) || "",
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
